import { render } from "./User-competence.vue?vue&type=template&id=43299d7b"
import script from "./User-competence.vue?vue&type=script&lang=js"
export * from "./User-competence.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__